module.exports = __webpack_public_path__ + "media/images/flags/4x3/tkl-935191a17c8c68076fad78146252c241.svg";